<template>
  <span class="post-channel">
    <img v-if="img" :src="img" width="20" class="round" alt="">

    <a v-if="title" :href="href" class="title">
      {{ title }}
    </a>
  </span>
</template>

<script>
import {defineComponent, onMounted, ref, watch} from "vue"
import Image from "@/services/Image"
import {getChannels} from "@/modules/post/plugins/title/services/channels"
import {useRouter} from "vue-router"

export default defineComponent({
  name: "Channel",

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const img = ref(null)
    const title = ref(null)
    const href = ref(null)

    const channels = ref(null)
    const router = useRouter()

    watch(() => getChannels(), (val) => {
      setChannels(val)
      renderTitle()
    })

    onMounted(() => {
      setChannels(getChannels())
      renderTitle()
    })

    function setChannels(val) {
      channels.value = val
    }

    function renderTitle() {
      const channelId = props.data["channel_id"]
      loadTitleChannel(channelId)
    }

    function loadTitleChannel(channelId) {
      if (!channels.value) return

      const result = channels.value[channelId]
      if (!result) return

      if (!result.image_host || !result.image_name) {
        throw Error("Отсутствует иконка")
      }

      img.value = Image.handle(result.image_host, result.image_name, 30, 30)
      title.value = result.title

      href.value = router.resolve({
        name: "Posts",
        params: { channel_id: channelId }
      }).href
    }

    return {
      img,
      title,
      href,
    }
  }
})
</script>

<style src="./css/style.css" scoped></style>
